<template>
  <section class='topHeader'>
    <p class='pageTitle'>爱排名，专注研究SEO技术10年！</p>
    <p class='quickVisit'>
      <span @click="goquestion()">常见问题</span>
      <span @click="gowork">我的工单</span>
      <!-- <span class='platformNav' @mouseover='showNavList=true' @mouseout='showNavList=false'> -->
      <span class='platformNav' style="display: none">
        平台导航
        <div class='navList'>
          <div>
            <p class="title">产品服务</p>
            <p class='list'>
              <span :class="{active: item1.active}" @click='gotoNextPage(item1)' @mouseover="item1.active=true" @mouseout="item1.active=false" v-for='item1 in navList.serviceList.list' :key='item1.id'>{{item1.text}}</span>
            </p>
            <p class="title">新闻资讯</p>
            <p class='list'>
              <span :class="{active: item2.active}" @click='gotoNextPage(item2)' @mouseover="item2.active=true" @mouseout="item2.active=false" v-for='item2 in navList.newsInfo.list' :key='item2.id'>{{item2.text}}</span>
            </p>
            <!--<p class="title">福利政策</p>-->
            <!--<p class='list'>-->
              <!--<span :class="{active: item3.active}" @click='gotoNextPage(item3)' @mouseover="item3.active=true" @mouseout="item3.active=false" v-for='item3 in navList.fuli.list' :key='item3.id'>{{item3.text}}</span>-->
            <!--</p>-->
          </div>
          <div>
            <p class="title">关于我们</p>
            <p class='list'>
              <span :class="{active: item4.active}" @click='gotoNextPage(item4)' @mouseover="item4.active=true" @mouseout="item4.active=false" v-for='item4 in navList.aboutus.list' :key='item4.id'>{{item4.text}}</span>
            </p>
            <p class="title">福利政策</p>
            <p class='list'>
              <span :class="{active: item3.active}" @click='gotoNextPage(item3)' @mouseover="item3.active=true" @mouseout="item3.active=false" v-for='item3 in navList.fuli.list' :key='item3.id'>{{item3.text}}</span>
            </p>
          </div>
        </div>
      </span>
    </p>
    <div class='loginTitle'>
      您好！
      <!--<span class='login' @click='loginDialogVisible=true' v-if='!isLoginState'>请登录</span>-->
      <a class="login" target="_blank" href="http://seo.aipaiming.cn/#/user/login/redirect=%2F" style="color: hsla(0,0%,100%,.6);">请登录</a>
      <!--<span class='register' @click='registerDialogVisible=true' v-if='!isLoginState'>免费注册</span>-->
       <a class="login" target="_blank" href="http://seo.aipaiming.cn/customer/#/user/reg" style="color: hsla(0,0%,100%,.6);">免费注册</a>
      <span class='login' v-if='isLoginState' @click='showUserCenter($event)'>{{isLoginUser}}</span>
      <span class='register' @click='click_logout' v-if='isLoginState'>[退出登录]</span>
      <!-- <span class='dashboard' style='margin-left: 20px;'>后台管理</span> -->
      <div class='userCenter' v-if='userCenterState' @click='stopPropagat($event)'>
        <img class='avast' :src="userAvast" alt="" @click="gorouter('/dashboard/board')">

        <p class='userName'>您好！<span @click="gorouter('/dashboard/board')" >{{isLoginUser}}</span></p>
        <ul class='imgList'>
          <li  @click = "gorouter('/dashboard/caiwuManagement/recharge')">
            <img src="../assets/images/reward.png" alt="">
            <p>财务流水</p>
          </li>
          <li @click="gorouter('/dashboard/optimizeManagement/keywordManagement')">
            <img src="../assets/images/quickEffect2.png" alt="">
            <p>优化管理</p>
          </li>
          <li @click="gorouter('/dashboard/optimizeManagement/shoppingCar')">
            <img src="../assets/images/shopcar2.png" alt="">
            <p >购物车</p>
          </li>
        </ul>
        <p class="dashboardEnter" @click='gotoDashboard'>进入后台管理</p>
      </div>
    </div>
    <el-dialog
      :visible.sync="loginDialogVisible"
      :show-close=false
      width="30%">
      <div class='loginModal'>
        <span class='closeBtn' @click='loginDialogVisible=false'>X</span>
        <div class='header'>
          <p class='title'>Hello!</p>
          <p class='subTitle'>欢迎来到爱排名</p>
          <img src="../assets/images/systemCopy.png" alt="">
        </div>
        <div class="form">
          <div>
            <el-input v-model="loginUsername" @blur='checkUsername'  type="text"  autocomplete='on' placeholder="用户名/手机号"></el-input>
          </div>
          <div>
            <el-input v-model="loginPassword" type='password' placeholder="密码"     @keyup.enter.native="login"></el-input>
          </div>
          <div class='rememberPwd'>
            <el-checkbox v-model="rememberPwd">记住密码</el-checkbox>
            <span @click='openForgetPwdModal'>忘记密码</span>
          </div>
          <div class='loginBtn' @click='login'>
            <p>登录</p>
          </div>
          <div class='footer'>
            <p>还没账号？<span @click='gotoRegister'>马上注册</span></p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="registerDialogVisible"
      :show-close=false
      width="36%">
      <div class='registerHeader'>
        <span class='closeBtn' @click='registerDialogVisible=false'>X</span>
        <div>
          <p class='title'>
            <img class='user' src="../assets/images/user.png" alt="">
            <span>注册</span>
          </p>
          <img class='zhizhu' src="../assets/images/zhizhu1.png" alt="">
          <!--<p class='subTitle'>创建一个新账户</p>-->
        </div>
        <div class='form'>
          <div>
            <el-input v-model="registerUserName" @blur="checkUsernameAvailable" placeholder="用户名"></el-input>
            <span class='requireFlag'>*</span>
          </div>
          <div class='code'>
            <el-input v-model="phone" @blur="checkMobileAvailable" placeholder="手机号"></el-input>
            <span class='btn' v-if='sendMsgState' @click='sendMsg'>获取验证码</span>
            <span class='btn' v-if='!sendMsgState'>重新获取验证码({{codeTimer}})</span>
            <span class='requireFlag'>*</span>
          </div>
          <div>
            <el-input v-model="registerCode" placeholder="验证码"></el-input>
            <span class='requireFlag'>*</span>
          </div>
          <div>
            <el-input v-model="registerPassword" type='password' placeholder="密码"></el-input>
            <span class='requireFlag'>*</span>
          </div>
          <div>
            <el-input v-model="qqNo" placeholder="QQ号"></el-input>
            <span class='requireFlag'>*</span>
          </div>
          <div>
            <el-input v-model="contracter" placeholder="联系人"></el-input>
            <span class='requireFlag'>*</span>
          </div>
          <div>
            <el-checkbox v-model="checked">已阅读并同意</el-checkbox><span @click='gotoService' style='color: #FC5F35; cursor: pointer;'>《服务条款》</span>
          </div>
          <div class="registerBtn">
            <p @click='registerAccount'>注 册</p>
          </div>
          <div class="footer">
            <p>已有账号 <span @click='gotoLogin'>登录</span></p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="forgetPwdDialogVisible"
      :show-close=false
      width="30%">
      <div class='forgetPwdModal'>
        <span class='closeBtn' @click='forgetPwdDialogVisible=false'>X</span>
        <div>
          <p class='title'>
            <img class='user' src="../assets/images/lock.png" alt="">
            <span>找回密码</span>
          </p>
        </div>
        <div class='form'>
          <!-- <div>
            <el-input v-model="forgetPwdUserName" placeholder="请输入手机号码"></el-input>
          </div> -->
          <div class='code'>
            <el-input v-model="forgetPwdUserName" placeholder="请输入手机号码"></el-input>
            <span class='btn' v-if='sendMsgState2' @click='sendMsg2'>获取验证码</span>
            <span class='btn' v-if='!sendMsgState2'>重新获取验证码({{codeTimer2}})</span>
          </div>
           <!--<div class='code'>-->
            <!--<el-input v-model="forgetPwdCode" placeholder="请输入图形验证码"></el-input>-->
            <!--<p class='imgCode'>-->
              <!--<img src="http://api.2paiming.com/api/Captcha" alt="">-->
            <!--</p>-->
            <!--<p class='refreshBtn'>-->
              <!--<img src="../assets/images/fresh_selected.png" alt="">-->
              <!--<span>刷新</span>-->
            <!--</p>-->
          <!--</div>-->
          <div>
            <el-input v-model="forgetPwdCode" placeholder="请输入手机验证码"></el-input>
          </div>
          <div>
            <el-input v-model="newPassword" type='password' placeholder="请设置新密码"></el-input>
          </div>
          <div class="confirmBtn">
            <p @click='resetPwd'>确 认</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="serviceVisible"
      :show-close=false
      width="60%">
      <div class='registerHeader'>
        <span class='closeBtn' @click='serviceVisible=false'>X</span>
        <div>
          <p class='title'>
            <span>服务条款</span>
          </p>
          <img class='zhizhu' src="../assets/images/zhizhu1.png" alt="">
          <textarea style="width: 90%;height: 400px" class="content">
            服务协议
            为了您能更好的使用爱排名服务（以下简称：本服务），您应当阅读并遵守《爱排名服务协议》（以下简称:本协议）等相关协议、规则。
            1、总则
            1.1 爱排名服务（以下简称"本服务"）是由江苏沃媒网络科技有限公司（以下简称"本公司"）与爱排名用户共同缔结的对双方具有约束力的有效契约。本协议由您和本公司签订。在您注册成为爱排名用户之前，请您务必谨慎阅读、充分理解各条款内容；一旦您选择"同意"并完成注册，说明您已充分阅读、理解并接受本协议的全部内容，即表示您同意遵循本协议之所有约定。
            1.2 爱排名向用户提供本网站上所展示的产品与服务（下称"爱排名服务"、"本服务"），并将不断更新服务内容，爱排名服务以爱排名网站上的相关云产品及服务介绍的页面展示以及向用户实际提供的为准。
            2、爱排名账户
            2.1 在使用本服务前，您必须先注册并取得本公司平台提供的爱排名会员账户，在完成注册或激活流程时，您必须同意并保证：
            2.1.1 您所填写的用户信息是真实、准确、完整、及时的，且保证爱排名可以通过您所填写的联系方式与您取得联系。
            2.1.2 您应根据爱排名对应服务的条例要求及时提供相应的身份证明等资料，否则爱排名有权拒绝向您提供相关服务。
            2.1.3 如果您提供的资料或信息包含有不正确、虚假的信息，爱排名将有权向您发出询问或要求改正的通知并保留取消您会员资格并结束为您提供服务的权利，爱排名对此不需承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
            2.1.4 您应对您的爱排名会员账户负责，只有您本人可以使用您的爱排名会员账户，该账户具有唯一性，不可转让、不可赠与、不可继承。若因您自身原因致使服务器数据、口令、密码等信息丢失或泄漏等，爱排名对此不需承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
            2.2 您须自行负责对您的爱排名账户和密码保密，且须对您在该登录名和密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议等）承担责任。您同意：
            2.2.1 如发现任何人未经授权使用您的爱排名账户和密码，或发生违反保密规定的任何其他情况，您会立即通知爱排名，并授权爱排名将该信息同步给爱排名网站。
            2.2.2 请确保您在每次登录爱排名平台结束时，以正确步骤退出爱排名平台。本公司不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。
            2.2.3 若因您提供的信息不完全，虚假等导致爱排名无法正确核实您的真实身份或爱排名无法正确判断您的需求等，而导致的爱排名无法为您进行及时处理，给您带来的损失，您应自行承担。同时，您理解爱排名对您的请求采取措施需要合理期限，对于您通知爱排名以及爱排名根据您的有效通知采取措施之前，由于他人行为已经给您造成的损失，爱排名不承担任何责任。
            3、平台服务使用守则
            为有效保障您使用本平台服务的合法权益，您理解并同意接受以下规则：
            3.1 您通过包括但不限于以下方式向爱排名发出的指令，均视为您本人的指令，不可撤回或撤销，您应自行对爱排名执行前述指令所产生的任何结果承担责任。
            3.1.1 通过您的爱排名账户和密码进行的所有操作（包括但不限于云查询提交和删除，云监控提交修改和删除等）；
            3.1.2 通过与您的账号绑定的手机号码或邮箱向爱排名发送的全部信息；
            3.2 您购买本服务后，仅可供自己使用，不得直接或间接以转让、出售、出租、合作等任何形式，有偿或无偿地将部分或全部的服务提供给他人使用。
            3.3 您应在本服务之外，妥善保管自己的账户和密码不向任何人透露，确保其安全性，并对自己的行为所引起的结果承担全部责任。
            3.4 您了解并同意本公司单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示为准，您同意并遵照服务规则是您使用本服务的前提。
            3.5 在您使用本服务时，本公司有权依照相应的服务收费介绍、订单或相关协议向您收取服务费用。本公司拥有制订及调整服务资费的权利，具体服务资费以您使用本服务时本网站上所列之收费方式公告或您与本公司达成的其他书面协议为准。
            3.6 爱排名可能会以手机短信或电子邮件（或电话或QQ等）方式通知您服务进展情况以及提示您进行下一步的操作，但爱排名不保证您能够收到或者及时收到该手机短信或电子邮件（或电话或QQ信息等），且不对此承担任何后果。因此，在服务过程中您应当及时登录到爱排名网站查看和进行交易操作。因您没有及时查看和对服务状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，爱排名不负任何责任。
            4、用户权利和义务
            4.1 您有权利享受爱排名提供的互联网技术和信息服务，并有权利在接受爱排名提供的服务时获得爱排名的技术支持、咨询等服务，服务内容详见本网站相关产品介绍。
            4.2 您保证不会利用技术或其他手段破坏或扰乱本网站及爱排名其他客户的网站。
            4.3 您应尊重爱排名及其他第三方的知识产权和其他合法权利，并保证在发生侵犯上述权益的违法事件时尽力保护爱排名及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；爱排名保留您侵犯爱排名合法权益时终止向您提供服务并不退还任何款项的权利。
            4.4 对由于您向爱排名提供的联络方式有误以及您用于接受爱排名邮件的电子邮箱安全性、稳定性不佳而导致的一切后果，您应自行承担责任，包括但不限于因您未能及时收到爱排名的相关通知而导致的后果和损失。
            4.5 您保证：
            4.5.1 您使用爱排名产品或服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用爱排名提供的服务进行存储、发布、传播如下信息和内容：违反国家法律法规政策的任何内容（信息）；违反国家规定的政治宣传或新闻信息；涉及国家秘密或安全的信息；封建迷信或淫秽、色情、下流的信息或教唆犯罪的信息；博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；妨碍互联网运行安全的信息；侵害他人合法权益的信息或其他有损于社会秩序、社会治安、公共道德的信息或内容;您同时承诺不得为他人发布上述不符合国家规定或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等;
            您承认爱排名有权在您违反上述约定时有权终止向您提供服务并不予退还任何款项，因您上述行为给爱排名造成损失的，您应予赔偿。 您保证您不会进行任何滥用爱排名资源的行为，一经发现，帐户将会被禁止，帐户余额也不予退回。 您保证注册时使用的手机号码、邮箱、QQ长期有效，一旦发现手机号码过期经通知后还未修改的，将视作无效用户，帐户将会被禁止，帐户余额也不予退回。
            4.5.2 使用爱排名产品或服务时，应遵守您与爱排名签订的服务条款、爱排名在2paiming.com相关页面上的管理规范、流程、服务说明、价格说明和您确认同意的订购页面的内容，包括但不限于：
            4.5.2.1 您应按时付款或续费；
            4.5.2.2 不应出现任何破坏或试图破坏网络安全的行为等； 如您违反上述保证，爱排名除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权限制您账户如新购产品或服务、续费等部分或全部功能，如因您上述行为给爱排名造成损失的，您应予赔偿。
            4.7 若您使用的某项服务中包含可下载的爱排名软件，则爱排名仅授予您非独占性的、不可转让的、非商业运营目的的个人使用许可。除非爱排名另有明示或与您另有约定外，您不得复制、修改、发布、出售或出租服务或所含软件的任何部分，也不得进行反向工程或试图提取该软件的源代码。
            5、爱排名权利和义务
            5.1 爱排名应根据您选择的服务以及交纳款项的情况向您提供合格的网络技术和信息服务。
            5.2 爱排名承诺对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：
            5.2.1 依据本服务条款或者您与爱排名之间其他服务协议、合同、在线条款等规定可以提供；
            5.2.2 依据法律法规的规定应当提供；
            5.2.3 行政、司法等职权部门要求爱排名提供；
            5.2.4 您同意爱排名向第三方提供；
            5.2.5 爱排名解决举报事件、提起诉讼而提交的；
            5.2.6 爱排名为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；
            5.2.7 爱排名为向您提供产品、服务、信息而向第三方提供的，包括爱排名通过第三方的技术及服务向您提供产品、服务、信息的情况。
            5.3 爱排名有权根据本服务条款的约定，根据您的服务使用情况，自您的账户余额中直接扣除相关服务费用。
            5.4 当存在如下情形之一时，爱排名有权对您名下账户资金的部分或全部进行冻结：
            5.4.1 国家法律、法规、政策、法律文书的规定；
            5.4.2 国家有权机关要求进行冻结的；
            5.4.3 您使用爱排名服务的行为涉嫌违反国家法律法规及行政规定的；
            5.4.4 爱排名基于单方面合理判断，认为您的账户操作、资金进出等存在异常时；
            5.4.5 他人向您账户错误汇入资金等导致您可能存在不当得利的；
            5.4.6 您遭到他人投诉， 且对方已经提供了一定证据的；
            5.4.7 爱排名根据自行合理判断，认为可能产生风险的其他情况。 爱排名按照前述规定对您的账户资金进行冻结后，将通过邮件、站内信、短信或电话等方式通知您按照相应的程序进行申诉。如果您按照本服务条款的要求进行申诉并经爱排名审核通过的，爱排名将立即解除资金冻结措施；如果您未在规定时间内进行申请，或您的申诉未能通过爱排名审核的，则您确认爱排名有权长期冻结该资金，或将相关冻结款项按原路退回该笔资金的充值来源账户（包括但不限于银行账户、支付宝账户、微信账户等）。
            6、隐私及其他个人信息的保护
            一旦您同意本服务条款或使用本服务，您即同意爱排名按照以下条款来使用和披露您的个人信息。
            6.1 登录名和密码
            在您注册帐户时，爱排名会要求您设置爱排名账户登录名和密码来识别您的身份，并设置密码提示问题及其答案，以便在您丢失密码时用以确认您的身份。您仅可通过您设置的密码来使用该账户，如果您泄漏了密码，您可能会丢失您的个人识别信息，并可能导致对您不利的法律后果。该账户和密码因任何原因受到潜在或现实危险时，您应该立即和爱排名取得联系，在爱排名采取行动前，爱排名对此不负任何责任。
            6.2 用户注册信息
            您完成账户注册或激活账户时，应向爱排名提供您的真实姓名、地址、国籍、电话号码和电子邮件地址，您还可以选择来填写相关附加信息（包括但不限于您公司所在的省份和城市、时区和邮政编码、传真号码、个人主页和您的职务）。为有针对性地向您提供新的服务和机会，您了解并同意爱排名及其关联公司或您登录的其他网站将通过您的电子邮件地址或该手机通知您这些信息。
            6.3 银行账户或其他支付账户信息息
            若爱排名所提供的服务需要您提供您的银行账户信息，在您提供相应信息后，爱排名将严格履行相关保密约定。
            6.4 登录记录
            为了保障您使用本服务的安全以及不断改进服务质量，爱排名将记录并保存您登录和使用本服务的相关信息，但爱排名承诺不将此类信息提供给任何第三方（除双方另有约定或法律法规另有规定及爱排名关联公司外）。
            6.5 广告
            爱排名会对爱排名用户的身份数据进行综合统计，并出于销售和奖励的需要使用或披露。
            6.6 外部链接
            本网站含有到其他网站的链接，但爱排名对其他网站的隐私保护措施不负任何责任。爱排名可能在任何需要的时候增加商业伙伴或共用品牌的网站。
            6.7 安全
            爱排名仅按现有技术提供相应的安全措施来使爱排名掌握的信息不丢失，不被滥用和变造。这些安全措施包括向其他服务器备份数据和对用户密码加密。尽管有这些安全措施，但爱排名不保证这些信息的一定安全。
            7、 系统中断或故障
            系统可能因下列状况无法正常运作，使您无法使用各项互联网服务时，爱排名不承担损害赔偿责任，该状况包括但不限于：
            7.1 爱排名在系统停机维护期间。
            7.2 电信设备出现故障不能进行数据传输的。
            7.3 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成爱排名系统障碍不能执行业务的。
            7.4 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。
            8、 责任范围及责任限制
            8.1 爱排名仅对本服务条款中列明的责任承担范围负责。
            8.2 本服务之合作单位，所提供之服务品质及内容由该合作单位自行负责。
            8.3 您了解并同意，因您使用本服务、违反本服务条款或在您的账户下采取的任何行动，而导致的任何第三方索赔，应且仅应由您本人承担。如果由此引起爱排名及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并承担由此造成的全部责任。
            8.4 在法律允许的情况下，爱排名对于与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不论是如何产生的，也不论是由对本服务条款的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本服务条款规定的排他性救济没有达到其基本目的，也应排除爱排名对上述损失的责任。
            8.5 除本服务条款另有规定或爱排名与您就某一具体产品及/或服务另有约定外，在任何情况下，您同意爱排名对本服务条款所承担的赔偿责任总额不超过向您收取的当次服务费用总额。
            9、 完整协议
            9.1 本服务条款由本服务条款与本网站公示的各项规则组成，相关名词可互相引用参照，如有不同理解，以本服务条款为准。
            9.2 本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。
            9.3 您对本服务条款理解和认同，您即对本服务条款所有组成部分的内容理解并认同，一旦您使用本服务，您和爱排名即受本服务条款所有组成部分的约束。
            9.4 本服务条款部分内容被有管辖权的法院认定为违法的，不因此影响其他内容的效力。
            10、商标、知识产权
            本网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由本公司依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
            非经本公司书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。
            11、法律适用与管辖
            本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并提交本协议签订地有管辖权的人民法院管辖。


          </textarea>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import { MessageBox, Message } from 'element-ui';
  import { Api } from '../service/api'
  import { setInterval, clearInterval } from 'timers';
  export default {
    name: 'TopHeader',
    data() {
      return {
        loginBtnState: false,
        userCenterState: false,
        showNavList: false,
        loginDialogVisible: false,
        registerDialogVisible: false,
        forgetPwdDialogVisible: false,
        serviceVisible: false,
        navList: {
          serviceList: {
            title: '产品服务',
            list: [
              {
                id: 1,
                text: '快速排名',
                // pageUrl: '/dashboard/optimizeManagement/keywordManagement',
                pageUrl: '/dashboard/optimizeManagement/quickRanking',
                active: false
              }, {
                id: 2,
                text: 'SEO优化',
                // pageUrl: '/index/result/seo',
                pageUrl: '/dashboard/optimizeManagement/SEOOptimize',
                active: false
              }, {
                id: 3,
                text: '积分优化',
                // pageUrl: '/index/result/list',
                pageUrl: '/dashboard/optimizeManagement/integrationOptimize',
                active: false
              }, {
                id: 4,
                text: '整站优化',
                pageUrl: '/dashboard/optimizeManagement/webOptimize',
                active: false
              },
            ]
          },
          newsInfo: {
            title: '新闻资讯',
            list: [
              /*{
                id: 1,
                text: '公司公告',
                pageUrl: '/index/componeyNotice',
                active: false
              }, */
              {
                id: 2,
                text: '常见问题',
                pageUrl: '/index/articleList/27',
                active: false
              }, {
                id: 3,
                text: '行业动态',
                pageUrl: '/index/articleList/29',
                active: false
              }, {
                id: 4,
                text: 'SEO干货',
                pageUrl: '/index/articleList/30',
                active: false
              }
            ]
          },
          fuli: {
            title: '福利政策',
            list: [
              {
                id: 1,
                text: '消费全返',
                pageUrl: '/dashboard/caiwuManagement/recharge',
                active: false
              }, {
                id: 2,
                text: '邀请奖励',
                pageUrl: '/dashboard/reward',
                active: false
              }, {
                id: 3,
                text: '',
                pageUrl: '',
                active: false
              }
            ]
          },

          aboutus: {
            title: '关于我们',
            list: [
              {
                id: 1,
                text: '公司简介',
                pageUrl: '/index/platformIntroduce',
                active: false
              }, {
                id: 2,
                text: '发展历程',
                pageUrl: '/index/articleList/20',
                active: false
              }, {
                id: 3,
                text: '联系我们',
                pageUrl: '/index/contactUs',
                active: false
              }, {
                id: 4,
                text: '媒体报道',
                pageUrl: '/index/mediaReport',
                active: false
              }
            ]
          }
        },
        // 注册信息
        registerUserName: '',     // 用户名
        phone: '',                // 手机号
        canSendMsg: false,
        sendMsgText: '获取验证码',
        sendMsgState: true,
        codeTimer: 60,
        registerCode: '',         // 手机验证码
        registerPassword: '',     // 注册密码
        qqNo: '',                 // qq
        contracter: '',           // 联系人
        checked: false,           // 是否已阅读并同意条款
        isLoginState: false,
        isLoginUser: '',
        // 登陆信息
        loginUsername:  localStorage.getItem('loginUsername'),
        loginPassword:  localStorage.getItem('loginpassword'),
        rememberPwd: false,
        sendMsgState2: true,
        codeTimer2: 60,
        forgetPwdUserName: '',
        forgetPwdCode: '',
        newPassword: '',
        userAvast: ''
      }
    },
    methods: {
        gorouter(path){
            this.$router.push({
                path: path
            })
        },
      checkUsername() {
        if(!this.loginUsername){
          return
        }
        let params = {
          needLoading: false,
          username: this.loginUsername,
        }
        Api.checkUsernameExist(params).then((res) => {
          if(res.data.code == 1){
            this.loginBtnState = true
          }else{
            this.loginBtnState = false
            Message({
              message: res.data.msg,
              type: 'success'
            })
          }
        })
      },
      goquestion(){
          this.$router.push({
              path: '/index/articleList/27'
          })
      } ,
      gowork(){
          this.$router.push({
              path: '/dashboard/orderManagement'
          })
      },
      gotoHome() {
        this.$router.push({
          path: '/'
        })
      },
      gotoNextPage(item) {
        if(item.pageUrl){
          this.$router.push({
            path: item.pageUrl
          })
        }
      },
      //点击用户名显示用户中心及后台管理入口
      showUserCenter(event) {
        this.userCenterState = true;
        event.stopPropagation();
      },
      stopPropagat(event) {
        event.stopPropagation();
      },
      // 获取短信验证码
      sendMsg() {
        if(!this.phone){
          Message({
            message: '手机号不能为空',
            type: 'success'
          })
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.phone))){
          Message({
            message: '手机号码有误，请重新填写',
            type: 'success'
          })
          return;
        }
        let params = {
          mobile: this.phone
        }
        Api.sendMsg(params).then((res) => {
          if(res.data.code == 1){
            this.sendMsgState = false;
            let timer = setInterval(() => {
              this.codeTimer--
              if(this.codeTimer == 0){
                this.sendMsgState = true;
                this.codeTimer = 60;
                clearInterval(timer)
              }
            }, 1000)

          }
          Message({
            message: res.data.msg,
            type: 'success'
          })
        })
      },
      // 注册账号
      registerAccount() {
        let userNamePattern = /^[a-zA-Z0-9]{3,8}$/;
      //  let userNamePattern =/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\_]{3,8}/g;
        let passwordPattern = /^[a-zA-Z0-9]{8,12}$/;
        if(!this.registerUserName){
          Message({
            message: '用户名不能为空',
            type: 'success'
          })
          return
        }
        let patrn=/^[a-zA-Z0-9\_\u4e00-\u9fa5]{3,10}$/;
        if(!patrn.test(this.registerUserName)){
          Message({
            message: '用户名必须是3-10位的数字,字母,汉字或下划线组成',
            type: 'success'
          })
          return
        }
        if(!this.phone){
          Message({
            message: '手机号不能为空',
            type: 'success'
          })
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.phone))){
          Message({
            message: '手机号码有误，请重新填写',
            type: 'success'
          })
          return;
        }
        if(!this.registerCode){
          Message({
            message: '验证码不能为空',
            type: 'success'
          })
          return
        }
        if(!this.registerPassword){
          Message({
            message: '密码不能为空',
            type: 'success'
          })
          return
        }
        // if(!passwordPattern.test(this.registerPassword)){
        //   Message({
        //     message: '密码必须为8-12位的数字或字母组成',
        //     type: 'success'
        //   })
        //   return
        // }
        if(!this.qqNo){
          Message({
            message: 'QQ号不能为空',
            type: 'success'
          })
          return
        }
        if(!(/^[1-9][0-9]{6,11}$/.test(this.qqNo))){
          Message({
            message: 'QQ号格式不对，请填写正确的QQ号',
            type: 'success'
          })
          return;
        }
        if(!this.contracter){
          Message({
            message: '联系人不能为空',
            type: 'success'
          })
          return
        }
        if(!this.checked){
          Message({
            message: '请勾选服务条款',
            type: 'success'
          })
          return
        }
        let params = {
          username: this.registerUserName,    // 用户名
          mobile: this.phone,                 // 手机号
          captcha: this.registerCode,         // 验证码
          password: this.registerPassword,    // 密码
          qq: this.qqNo,                      // qq
          link: this.contracter,              // 联系人
          agree: this.checked,                // 是否已阅读并同意
        }
        Api.register(params).then((res) => {
          Message({
            message: res.data.msg,
            type: 'success'
          })
          if(res.data.code == 1){
            this.registerDialogVisible = false;
            this.registerUserName = '';
            this.phone = '';
            this.registerCode = '';
            this.registerPassword = '';
            this.qqNo = '';
            this.contracter = '';
            this.checked = '';
          }
        })
      },
      // 获取短信验证码
      sendMsg2() {
        if(!this.forgetPwdUserName){
          Message({
            message: '手机号不能为空',
            type: 'success'
          })
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.forgetPwdUserName))){
          Message({
            message: '手机号码有误，请重新填写',
            type: 'success'
          })
          return;
        }
        let params = {
          mobile: this.forgetPwdUserName,
          event: 'findpwd'
        }
        Api.sendMsg(params).then((res) => {
          if(res.data.code == 1){
            this.sendMsgState2 = false;
            let timer2 = setInterval(() => {
              this.codeTimer2--
              if(this.codeTimer2 == 0){
                this.sendMsgState2 = true;
                this.codeTimer2 = 60;
                clearInterval(timer2)
              }
            }, 1000)

          }
          Message({
            message: res.data.msg,
            type: 'success'
          })
        })
      },
      resetPwd() {
        let params = {
          mobile: this.forgetPwdUserName,
          newpassword: this.newPassword,
          captcha: this.forgetPwdCode,
        }
        Api.resetpwd(params).then((res) => {
          Message({
            message: res.data.msg,
            type: 'success'
          })
          if(res.data.code == 1) {
            this.forgetPwdDialogVisible = false;
            this.forgetPwdUserName = '';
            this.newPassword = '';
            this.forgetPwdCode = '';
            this.sendMsgState2 = true;
            this.codeTimer2 = 60;
          }
        })
      },
      register() {

      },
      login() {
        if(!this.loginUsername){
          Message({
            message: '请输入用户名/手机号',
            type: 'success'
          })
          return
        }
        if(!this.loginBtnState){
          Message({
            message: '用户名不存在',
            type: 'success'
          })
          return
        }
        if(!this.loginPassword){
          Message({
            message: '请输入密码',
            type: 'success'
          })
          return
        }

        let params = {
          account: this.loginUsername,
          password: this.loginPassword
        }
        Api.login(params).then((res) => {
          Message({
            message: res.data.msg,
            type: 'success'
          })
          if(res.data.code == 1){
            localStorage.setItem('loginUsername', res.data.data.userinfo.username)
            localStorage.setItem('loginpassword', this.loginPassword)

            localStorage.setItem('loginUsername',  res.data.data.userinfo.username)
            localStorage.setItem('avatar', res.data.data.userinfo.avatar)
            localStorage.setItem('user_id',res.data.data.userinfo.id)
            localStorage.setItem('aipaimingToken', res.data.data.userinfo.token)
            localStorage.setItem('aipaimingToken', res.data.data.userinfo.token)
            this.isLoginUser = res.data.data.userinfo.username;
            this.loginDialogVisible = false;
            this.isLoginState = true;
            this.loginUsername = '';
            this.loginPassword = '';
            this.rememberPwd = false;
            Api.userCenter({}).then((res) => {
              if(res.data.code == 1) {
                localStorage.setItem('aipaimingAvast', res.data.data.usernfo.avatar)
                this.userAvast = res.data.data.usernfo.avatar
              }
            })
          }
        })

      },
      // 检测用户名
      checkUsernameAvailable() {
        if(this.registerUserName.length == 0){
          return
        }
        let patrn=/^[a-zA-Z0-9\_\u4e00-\u9fa5]{3,8}$/;
        if(!patrn.test(this.registerUserName)){
          Message({
            message: '用户名由3-8位的数字,字母,汉字或下划线组成',
            type: 'success'
          })
          return
        }
        let params = {
          username: this.registerUserName,
          id: '',    // 排除会员ID
          needLoading: false,
        };
        Api.checkUsernameAvailable(params).then((res)=> {
          if(res.data.code != 1){
            Message({
              message: res.data.msg,
              type: 'success'
            })
          }
        })
      },
      // 检测手机
      checkMobileAvailable() {
        if(this.phone.length == 0){
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.phone))){
          Message({
            message: '手机号码有误，请重新填写',
            type: 'success'
          })
          return;
        }
        let params = {
          mobile: this.phone,
          id: '',    // 排除会员ID
          needLoading: false,
        };
        Api.checkMobileAvailable(params).then((res)=> {
          if(res.data.code != 1){
            this.canSendMsg = false;
            Message({
              message: res.data.msg,
              type: 'success'
            })
          }else{
            this.canSendMsg = true;
          }
        })
      },
      gotoLogin() {
        this.registerDialogVisible = false;
        this.loginDialogVisible = true;
      },
      gotoRegister() {
        this.loginDialogVisible = false;
        this.registerDialogVisible = true;
      },
      gotoService() {
        //this.registerDialogVisible = false;
        this.serviceVisible = true
      },
      openForgetPwdModal() {
        this.loginDialogVisible = false;
        this.forgetPwdDialogVisible = true;
      },
      //点击退出登录
      click_logout() {
        MessageBox('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {};
          Api.logout(params).then((res) => {
            localStorage.removeItem('loginUsername')
            localStorage.removeItem('aipaimingToken')
            this.isLoginState = false;
            Message({
              message: res.data.msg,
              type: 'success'
            })
          })
        }).catch(() => {

        });
      },
      gotoDashboard() {
        this.$router.push({
          path: '/dashboard'
        })
      }
    },
    mounted() {
      if(localStorage.getItem('loginUsername')){
        this.loginUsername  = localStorage.getItem('loginUsername')
        this.loginPassword  = localStorage.getItem('loginpassword')
        this.isLoginUser = localStorage.getItem('loginUsername');
        this.isLoginState = true
        if(localStorage.getItem('aipaimingAvast')){
          this.userAvast = localStorage.getItem('aipaimingAvast')
        }
      }else{
        this.isLoginState = false
      }
      document.body.addEventListener('click', (e) => {
        this.userCenterState = false;
      })
    }
  }
</script>
<style scoped lang='scss'>
  section{
    height: 50px;
    background: #101317;
    color: rgba(255,255,255,0.6);
    padding: 0 2.5rem;
    clear: both;
    overflow: hidden;
    .pageTitle, .quickVisit, .loginTitle{
      line-height: 50px;
      font-size: 12px;
      float: left;
      &.loginTitle, &.quickVisit{
        float: right;
        margin-left: 60px;
        span{
          cursor: pointer;
        }
        .login{
          margin: 0 10px 0 4px;
        }
      }
      &.loginTitle{
        position: relative;
        left: 0;
        top: 0;
        .userCenter{
          position: fixed;
          top: 44px;
          z-index: 100;
          width: 200px;
          height: 280px;
          background: #181C24;
          padding: 20px 15px;
          .avast{
            width: 50px;
            height: 50px;
            cursor: pointer;
            border-radius: 30px;
          }
          .userName{
            color: #fff;
            font-size: 12px;
            line-height: 24px;
            span{
              color: #FC5F35;
            }
          }
          .imgList{
            display: flex;
            margin-top: 10px;
            li{
              flex: 1;
              padding: 5px;
              cursor: pointer;
              &:hover{
                background: #666;
              }
              img{
                width: 20px;
              }
              p{
                font-size: 10px;
                line-height: 20px;
                white-space: nowrap;
              }
            }
          }
          .dashboardEnter{
            border: 1px solid #FC5F35;
            color:#FC5F35;
            font-size: 13px;
            line-height: 26px;
            width: 120px;
            margin: 20px auto 0;
            cursor: pointer;
          }
        }
      }
      &.quickVisit{
        display: flex;
        span{
          display: block;
          cursor: pointer;
          width: 58px;
          text-align: center;
          &.platformNav{
            position: relative;
            top: 0;
            left: 0;
            .navList{
              position: fixed;
              right: 2.5rem;
              top: 40px;
              z-index: 1000;
              background: #fff;
              width: 750px;
              height: 250px;
              text-align: left;
              padding: 20px 0;
              display: none;
              >div{
                flex: 1;
                border-right: 1px solid #eee;
                padding: 0 20px 0 15px;
                &:nth-of-type(2){
                  border-right: 0;
                }
                .title{
                  line-height: 32px;
                  font-size: 16px;
                  position: relative;
                  left: 0;
                  top: 0;
                  color: #000;
                  font-weight: 600;
                  padding-left: 20px;
                  margin-top: 12px;
                  &:nth-of-type(1){
                    margin-top: 0;
                  }
                  &:before{
                    content: '';
                    display: block;
                    width: 2px;
                    height: 15px;
                    background: #FC5F35;
                    position: absolute;
                    left: 14px;
                    top: 9px;
                  }
                }
                .list{
                  line-height: 28px;
                  padding-left: 20px;
                  display: flex;
                  justify-content: space-between;
                  span{
                    color: #777;
                    padding: 0;
                    display: block;
                    font-size: 14px;
                    white-space: nowrap;
                    &:hover{
                      color: #FC5F35;
                    }
                  }
                }
              }
            }
            &:hover{
              .navList{
                display: flex;
              }
            }
          }
        }
      }
    }
    .registerHeader{
      position: relative;
      left: 0;
      top: 0;
      height: 550px;
      padding: 34px;
      .closeBtn{
        display: block;
        width: 30px;
        height: 30px;
        background: #FC5F35;
        color: #000;
        border-radius: 50%;
        position: absolute;
        right: -15px;
        top: -15px;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
      }
      img{
        &.user{
          width: 26px;
          height: 28px;
          margin-top: 12px;
        }
        &.zhizhu{
          position: absolute;
          right: 40px;
          top: 0;
          width: 20px;
        }
      }
      .title{
        font-size: 32px;
        font-weight: 600;
        width: 100%;
        text-align: left;
        color: #000;
        span{
          margin-left: 10px;
        }
        img{
          float: left;
        }
      }
      .content{
        text-align: left;
        margin-top: 20px;
        padding: 0 15px;
        font-size: 13px;
        line-height: 20px;
      }
      .subTitle{
        font-size: 13px;
        color: #999;
        text-align: left;
        line-height: 16px;
        margin-top: -4px;
      }
      .form{
        margin-top: 10px;
        >div{
          display: flex;
          margin-top: 12px;
          .requireFlag{
            line-height: 40px;
            margin-left: 10px;
            color: red;
          }
          &.code{
            position: relative;
            left: 0;
            top: 0;
            .btn{
              position: absolute;
              right: 17px;
              top: 1px;
              display: block;
              padding: 0 6px;
              line-height: 38px;
              background: #FC5F35;
              border-radius: 4px;
              color: #fff;
              cursor: pointer;
              font-size: 12px;
            }
          }
          &.registerBtn{
            p{
              width: 100%;
              height: 40px;
              line-height: 40px;
              border-radius: 5px;
              background: #FC5F35;
              color: #fff;
              font-weight: 600;
              font-size: 17px;
              text-align: center;
              cursor: pointer;
            }
          }
          &.footer{
            color: #999;
            span{
              color: #FC5F35;
              cursor: pointer;
            }
          }
        }
      }
    }
    .loginModal{
      height: 450px;
      background: #fff;
      padding: 60px;
      position: relative;
      left: 0;
      top: 0;
      .closeBtn{
        display: block;
        width: 30px;
        height: 30px;
        background: #FC5F35;
        color: #000;
        border-radius: 50%;
        position: absolute;
        right: -15px;
        top: -15px;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
      }
      .header{
        position: relative;
        left: 0;
        top: 0;
        text-align: left;
        .title{
          font-size: 36px;
          font-weight: 600;
          color: #000;
        }
        img{
          position: absolute;
          top: -20px;
          right: 0;
          transform: rotate(220deg);
          width: 50px;
        }
      }
      .form{
        margin-top: 40px;
        >div{
          display: flex;
          margin-top: 20px;
          &.rememberPwd{
            display: flex;
            justify-content: space-between;
            span{
              color: #FC5F35;
              cursor: pointer;
            }
          }
          &.loginBtn{
            p{
              width: 50%;
              background: #FC5F35;
              color: #fff;
              font-weight: 600;
              font-size: 18px;
              line-height: 40px;
              height: 40px;
              border-radius: 5px;
              cursor: pointer;
            }
          }
          &.footer{
            margin-top: 30px;
            color: #999;
            font-size: 12px;
            span{
              color: #FC5F35;
              cursor: pointer;
              font-weight: 600;
            }
          }
        }
      }
    }
    .forgetPwdModal{
      position: relative;
      left: 0;
      top: 0;
      height: 400px;
      padding: 34px;
      .closeBtn{
        display: block;
        width: 30px;
        height: 30px;
        background: #FC5F35;
        color: #000;
        border-radius: 50%;
        position: absolute;
        right: -15px;
        top: -15px;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
      }
      .code{
        position: relative;
        left: 0;
        top: 0;
        .btn{
          position: absolute;
          right: 0;
          top: 0px;
          display: block;
          padding: 0 6px;
          line-height: 40px;
          background: #FC5F35;
          border-radius: 4px;
          color: #fff;
          cursor: pointer;
          font-size: 12px;
        }
      }
      .title{
        font-size: 20px;
        font-weight: 600;
        width: 100%;
        text-align: center;
        color: #000;
        span{
          margin-top: -2px;
        }
        img{
          width: 18px;
          height: 22px;
        }
      }
      .form{
        margin-top: 10px;
        >div{
          display: flex;
          margin-top: 20px;
          .requireFlag{
            line-height: 40px;
            margin-left: 10px;
            color: red;
          }
          &.code{
            position: relative;
            left: 0;
            top: 0;
            .imgCode{
              position: absolute;
              right: 70px;
              top: 5px;
            }
            .refreshBtn{
              position: absolute;
              right: 0;
              top: 0;
              line-height: 40px;
              border-radius: 4px;
              color: #FC5F35;
              width: 60px;
              padding-left: 4px;
              font-size: 12px;
              cursor: pointer;
              img{
                position: absolute;
                left: 2px;
                top: 12px;
                width: 16px;
              }
            }
          }
          &.confirmBtn{
            p{
              width: 100%;
              height: 40px;
              line-height: 40px;
              border-radius: 5px;
              background: #FC5F35;
              color: #fff;
              font-weight: 600;
              font-size: 17px;
              text-align: center;
              cursor: pointer;
            }
          }
          &.footer{
            color: #999;
            span{
              color: #FC5F35;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue